import { useSpecialProfileQuery } from '#pplx/frontend/apps/ask/queries/user-queries/useSpecialProfileQuery.js';
import { useUserInfo } from '#pplx/frontend/user-info/useUserInfo.js';
import { useMemo } from 'react';
/**
 * Hook that provides user capabilities including government request origin detection
 * and special capabilities like unlimited pro search, unlimited research, etc.
 */
export function useUserCapabilities() {
    // Fetch government origin data from unified user info endpoint
    const { query: userInfoQuery } = useUserInfo({
        enabled: true,
        reason: 'user-capabilities',
    });
    // Use query data which is possibly undefined to preserve existing loading behavior
    const isGov = userInfoQuery.data?.isGov;
    // Fetch special profile when government origin is detected
    const specialProfileName = isGov ? 'us_government_or_military' : '';
    const { data: specialProfileData } = useSpecialProfileQuery(specialProfileName, 'user-capabilities');
    // Combine the data into user capabilities
    const userCapabilities = useMemo(() => {
        const specialCapabilities = {
            unlimitedProSearch: Boolean(specialProfileData?.unlimitedProSearch),
            maxModelSelection: Boolean(specialProfileData?.maxModelSelection),
            unlimitedResearch: Boolean(specialProfileData?.unlimitedResearch),
            fileUpload: Boolean(specialProfileData?.fileUpload),
        };
        return {
            isGovernmentRequestOrigin: isGov,
            specialCapabilities,
        };
    }, [isGov, specialProfileData]);
    return userCapabilities;
}
//# sourceMappingURL=useUserCapabilities.js.map